const { ccclass, property } = cc._decorator;
import EventManager from "../../../../manager/event_manager";
import TimeManager from "../../../../manager/time_manager";
import { NotifyData } from "../../../public/notify_data";

class ILableData{
    label:cc.RichText;
    totaldis:number;//总位置
    crupos:number;//当前位置
    triggerpos:number;//触发下个出现的位置
    isTrigger:boolean;
}

@ccclass
export default class MarqueeComponent extends cc.Component {

    @property(cc.Node)
    root: cc.Node = null
    @property(cc.RichText)
    labelPrefab: cc.RichText = null

    @property(cc.Mask)
    mask: cc.Mask = null

    @property(cc.Float)
    offset: number = 0

    @property(cc.Float)
    startOffset: number = 0

    @property(cc.Float)
    endOffset: number = 0

    @property(cc.Float)
    speed: number = 100

    @property(cc.String)
    tag:string="";
    protected m_availableLabelQueue: ILableData[] = []
    protected m_MoveLabel:ILableData[] = [];//正在播放着lab
    protected m_message_queue: any[] = []
    private timeID:number;
    private step:number = 1;
    private isPlayNext:boolean = false;
    onLoad()
    {
        this.isPlayNext = true;
        this.cancleTime();
    }

    onEnable(){
        if (this.tag != 'hall') {//大厅不回收
            this.resetMarquee();
        }
        this.showMarquee(this.m_MoveLabel.length > 0);
        this.beginPlayMessage();
        this.bindEvent();
        this.createTimer();
    }

    onDisable(){
        this.unbindEvent();
        if (this.tag != 'hall') {
            this.cancleTime();
            this.resetMarquee();
        }
    }

    createTimer(){
        if (this.m_message_queue.length > 0) {
            this.createTime();
        }
    }

    showMarquee(show: boolean){
        this.root.active = show
    }

    update(){
        this.updateLabPos();
    }

    updateLabPos(){
        for (let idx = 0; idx < this.m_MoveLabel.length; idx++) {
            let moveLab = this.m_MoveLabel[idx];
            moveLab.crupos -= this.step;
            moveLab.label.node.setPosition(moveLab.crupos,0);
            if (moveLab.crupos <= moveLab.triggerpos && !moveLab.isTrigger) {//触发下以条
                this.isPlayNext = true;//可播放next lab
                moveLab.isTrigger = true;
            }
            
            if (moveLab.crupos <= moveLab.totaldis) {//移动结束
                this.playLableOver();
            }
        }

        if (this.isPlayNext) {
            this.playNextLab();
        }
    }

    //播放下一条
    playNextLab(){
        if (this.isPlayNext) {
            let message = this.m_message_queue[0];
            if (message) {
                if ( (message.count != undefined) 
                    && message.count > 0) {
                    let text = JSON.parse(message.content).content
                    this.showMarquee(true)
                    this.playMessage(text)
                    this.isPlayNext = false;
                    message.count--;
                } else {
                    this.m_message_queue.shift()
                    if (message) {
                        NotifyData.removeMessage(message);
                    }
                }
            }
        }
    }

    resetMarquee(){
        let deleteQueue = this.m_MoveLabel.concat([]);
        let count = deleteQueue.length;
        while (count > 0) {
            count --;
            let data = deleteQueue.shift();
            this.addToAvailableLabel(data);
        }
        this.m_MoveLabel.length = 0;
        this.m_MoveLabel = [];
        this.isPlayNext = true;
    }

    playLableOver(){
        let data = this.m_MoveLabel.shift();
        this.addToAvailableLabel(data);
        if (this.m_MoveLabel.length <= 0) {
            this.showMarquee(false)
        }
    }

    playMessage(text: string){
        let self = this
        let maskWidth = self.mask.node.width
        let data = self.getAvailableLabel() 
        data.crupos = 0; 
        let label = data.label;    
        label.string = text
        let startPosX = maskWidth * 0.5 + self.startOffset+100
        label.node.position = cc.v2(startPosX, label.node.position.y)
        label.node.active = true;
        let labelWidth = self.calcLabelWidth(label)
        let totaldis = labelWidth + maskWidth + self.startOffset - self.endOffset;
        data.totaldis = -totaldis + startPosX
        data.triggerpos = startPosX - (labelWidth + self.offset)
        data.crupos = startPosX;
        data.isTrigger = false;
        this.m_MoveLabel.push(data);
    }
    //消息过滤 只针对当前模块注册的对应标签
    messageFilter(msg)
    {   
        if (this.tag == 'hall') {
            return true;
        }
        return msg.tag == this.tag?true:false;
    }

    protected getAvailableLabel(): ILableData{
        let data = this.m_availableLabelQueue.shift()
        if(!data){
            let lbData:ILableData = {
                label:this.cloneLabel(),
                crupos: 0,
                totaldis: 0,
                triggerpos:0,
                isTrigger:false,
            }
            data = lbData;
        }
        return data
    }

    protected cloneLabel(){
        let node = cc.instantiate(this.labelPrefab.node)
        node.parent = this.labelPrefab.node.parent
        node.position = this.labelPrefab.node.position
        node.scale = this.labelPrefab.node.scale
        return node.getComponent(cc.RichText)
    }

    protected addToAvailableLabel(data: ILableData){
        data.label.node.active = false;
        this.m_availableLabelQueue.push(data)
    }

    protected calcLabelWidth(label: cc.RichText): number{
        return label.node.width
    }

    //栓选最新数据
    protected beginPlayMessage(){
        let messages = NotifyData.instance.messageQueue;
        this.m_message_queue = [];
        for (let idx = 0; idx < messages.length; idx++) {
            let msg = messages[idx];
            NotifyData.pushMessage(this.m_message_queue,msg,this.messageFilter.bind(this))
        }
        MarqueeComponent.sortQueue(this.m_message_queue);
        NotifyData.cutQueue(this.m_message_queue);
    }

    static sortQueue(messagequeue:any[]){
        messagequeue.sort(function(a, b){
            let L1 = JSON.parse(a.content).level
            let L2 = JSON.parse(b.content).level
            return L2 - L1
        })
    }

    //新增消息
    private on_msg_coming(msg:any){
        if (msg.notifyType = "broadcast") {
            NotifyData.pushMessage(this.m_message_queue,msg,this.messageFilter.bind(this));
            MarqueeComponent.sortQueue(this.m_message_queue);
            NotifyData.cutQueue(this.m_message_queue);
            this.createTimer();
        }
    }

    private clearMessage(){
        this.cancleTime();
        this.resetMarquee();
        this.showMarquee(false);
        this.m_message_queue = [];
    }

    private cancleTime(){
        if (this.timeID) {
            TimeManager.instance.cancelSchedule(this.timeID);
            this.timeID = null;
        }
    }

    private createTime(){
        if (this.timeID == null) {
            this.timeID = TimeManager.instance.doSchedule(this.update.bind(this),0,cc.macro.REPEAT_FOREVER);
        }
    }

    private bindEvent() {
        EventManager.instance.on('Event_Notify_Data', this.on_msg_coming, this, true)
        EventManager.instance.on('_clear_message_',this.clearMessage,this,true);
    }

    private unbindEvent() {
        EventManager.instance.off('Event_Notify_Data', this.on_msg_coming,this)
        EventManager.instance.off('_clear_message_',this.clearMessage,this);
    }

    //销毁
    onDestroy()
    {
        this.unbindEvent();
        this.cancleTime();
    }

}
